import { render, staticRenderFns } from "./CustomStateEffect.vue?vue&type=template&id=2e49a28a&scoped=true&"
import script from "./CustomStateEffect.vue?vue&type=script&lang=js&"
export * from "./CustomStateEffect.vue?vue&type=script&lang=js&"
import style0 from "./CustomStateEffect.vue?vue&type=style&index=0&id=2e49a28a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49a28a",
  null
  
)

export default component.exports